import React, {createContext, useState} from 'react';
import html2canvas from 'html2canvas';
import Swal from "sweetalert2";
import axios from "axios";

export const AppContext = createContext();

export default function AppStore(props){
    const [loading, setLoading] = useState(false);
    //const [navFlag, setNavFlag] = useState(false);
    
    const setting = {
        loading,
        setLoading,
        /*
        navFlag,
        setNavFlag: (updateNavFlag) => {
            setNavFlag(updateNavFlag)
        },
        */
        capture: () => {
            //캡쳐 기능 -> ITSM과 연결
            //https://yong-nyong.tistory.com/53
            if(window.location.pathname !== '/Logout' && window.location.pathname !== '/Login'){
                /*
                html2canvas(document.getElementById("whole")).then((canvas) => {
                    const link = document.createElement('a');
                    document.body.appendChild(link);
                    link.href = canvas.toDataURL('image/png');
                    link.download = `[오류]-${(new Date()).getFullYear()}_${(new Date()).getMonth() + 1}_${(new Date()).getDate()}_${(new Date()).getHours()}_${(new Date()).getMinutes()}_${(new Date()).getSeconds()}`+' ['+window.location.href+'].png';
                    link.click();
                    document.body.removeChild(link);
                });
                Swal.fire({
                    title: '<p style="color:red">오류</p>',
                    html: '오류가 발생하여 화면이 캡쳐 되었습니다.<br/>캡쳐된 화면을 첨부하여 상단 1:1문의를 통해 확인 요청 부탁드립니다.',
                    confirmButtonText: '확인'
                });
                */
            }
            
        },
        getMaxListID: (list) => {
            let maxID = 0;
            if(list.length > 0){
                for (let i = 0; i < list.length; i++) {
                    let value = list[i].id;
                    if (value > maxID) maxID = value;
                }
            }
            return maxID;
        },
        convertFileSize: (sizeInBytes) => {
            if (sizeInBytes < 1024) {
                return sizeInBytes + "Bytes";
            } else if (sizeInBytes < 1024 * 1024) {
            const kilobytes = sizeInBytes / 1024;
                return kilobytes.toFixed(2) + "KB";
            } else if (sizeInBytes < 1024 * 1024 * 1024) {
            const megabytes = sizeInBytes / (1024 * 1024);
                return megabytes.toFixed(2) + "MB";
            } else {
            const gigabytes = sizeInBytes / (1024 * 1024 * 1024);
                return gigabytes.toFixed(2) + "GB";
            }
        },

        convertFileTypeName: (filetype) => {
            // 이미지
            if (filetype === 'image/png') return 'PNG';
            else if (filetype === 'image/gif') return 'GIF';
            else if (filetype === 'image/jpeg') return 'JPG';
            else if (filetype === 'image/x-icon') return '아이콘';
            else if (filetype === 'image/bmp') return 'BMP';
            else if (filetype === 'image/webp') return 'WebP';
            else if (filetype === 'image/svg+xml') return 'SVG';
            else if (filetype === 'image/tiff') return 'TIFF';
            else if (filetype === 'image/heic') return 'HEIC';

            // 문서
            else if (filetype === 'application/pdf') return 'PDF';
            else if (filetype === 'application/msword' 
                || filetype === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') return 'Word';
            else if (filetype === 'application/vnd.ms-powerpoint' 
                || filetype === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') return 'PPT';
            else if (filetype === 'application/vnd.ms-excel' 
                || filetype === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') return 'Excel';
            else if (filetype === 'application/rtf') return 'RTF';
            else if (filetype === 'application/x-hwp' || filetype === 'application/haansofthwp') return 'HWP';
            else if (filetype === 'application/vnd.oasis.opendocument.text') return 'ODT';
            else if (filetype === 'application/epub+zip') return 'EPUB';
            else if (filetype === 'text/plain') return '텍스트';
            else if (filetype === 'application/csv' || filetype === 'text/csv') return 'CSV';

            // 압축
            else if (filetype === 'application/x-zip-compressed' || filetype === 'application/zip') return '압축(ZIP)';
            else if (filetype === 'application/x-rar-compressed') return '압축(RAR)';
            else if (filetype === 'application/x-7z-compressed') return '압축(7Z)';
            else if (filetype === 'application/gzip') return '압축(GZ)';
            else if (filetype === 'application/x-tar') return '압축(TAR)';

            // 코드 / 데이터
            else if (filetype === 'text/x-python') return 'Python';
            else if (filetype === 'application/javascript') return 'JavaScript';
            else if (filetype === 'application/json') return 'JSON';
            else if (filetype === 'application/xml') return 'XML';
            else if (filetype === 'text/html') return 'HTML';
            else if (filetype === 'text/css') return 'CSS';
            else if (filetype === 'application/sql') return 'SQL';
            else if (filetype === 'application/java-archive') return 'JAR';
            else if (filetype === 'application/x-sh') return 'Shell Script';

            // 도면 (2D CAD)
            else if (['application/acad','application/x-acad','application/autocad_dwg','image/vnd.dwg'].includes(filetype)) return 'DWG';
            else if (['application/dxf','application/x-dxf','image/vnd.dxf'].includes(filetype)) return 'DXF';

            // 도면 (3D CAD)
            else if (filetype === 'application/step' || filetype === 'application/x-step') return 'STEP';
            else if (filetype === 'application/iges' || filetype === 'application/x-iges') return 'IGES';
            else if (filetype === 'application/sldprt' || filetype === 'application/x-sldprt') return 'SolidWorks Part';
            else if (filetype === 'application/sldasm' || filetype === 'application/x-sldasm') return 'SolidWorks Assembly';
            else if (filetype === 'application/stl' || filetype === 'application/x-stl') return 'STL';
            else if (filetype === 'application/obj' || filetype === 'application/x-obj') return 'OBJ';
            else if (filetype === 'model/3mf') return '3MF';

            // 동영상 / 오디오
            else if (filetype === 'video/mp4') return 'MP4';
            else if (filetype === 'video/x-msvideo') return 'AVI';
            else if (filetype === 'video/x-matroska') return 'MKV';
            else if (filetype === 'video/quicktime') return 'MOV';
            else if (filetype === 'audio/mpeg') return 'MP3';
            else if (filetype === 'audio/wav') return 'WAV';
            else if (filetype === 'audio/ogg') return 'OGG';
            else if (filetype === 'audio/flac') return 'FLAC';

            else return '';

        },
        ITEM_FULL_SPEC_MAKE: (...args) => {
            let spec = '';
            let dims = args;
            if (args.length >= 4 && typeof args[0] === 'string') {
                spec = (args[0] || '');
                if (spec.trim() === '') return '';   // ← spec이 빈 문자열이면 그대로 빈 값
                dims = args.slice(1);
            }
            const nums = dims.slice(0, 3).map(v => {
                if (v == null || v === '') return 0;
                const n = typeof v === 'number' ? v : parseFloat(String(v));
                return Number.isFinite(n) ? n : 0;
            });
            const allZero = nums.length === 0 || nums.every(n => n === 0);
            const suffix = allZero ? '' : ` ${nums.join(' x ')}`;
            return spec + suffix;
        },
        YYYY_MM_DD: () => {
            return (new Date()).getFullYear() + '-' + ("0" + (1 + (new Date()).getMonth())).slice(-2) + '-' + ("0" + (new Date()).getDate()).slice(-2);
        },
        YYYY_MM_01: () => {
            return (new Date()).getFullYear() + '-' + ("0" + (1 + (new Date()).getMonth())).slice(-2) + '-01';
        },
        YYYY_MM_DD_7: () => {
            return (new Date(Date.now() - 7*24*60*60*1000)).getFullYear() + '-' + ("0" + (1 + (new Date(Date.now() - 7*24*60*60*1000)).getMonth())).slice(-2) + '-' + ("0" + (new Date(Date.now() - 7*24*60*60*1000)).getDate()).slice(-2);
        },
        HH_MI_SS: () => {
            return (new Date()).getHours().toString().padStart(2,'0')+'_'+(new Date()).getMinutes().toString().padStart(2,'0')+'_'+(new Date()).getSeconds().toString().padStart(2,'0');
        },
        YYYY_MM_DD_HH_MI_SS: () => {
            return (new Date()).getFullYear()+'_'+((new Date()).getMonth() + 1).toString().padStart(2,'0')+'_'+(new Date()).getDate().toString().padStart(2,'0')+'_'+(new Date()).getHours().toString().padStart(2,'0')+'_'+(new Date()).getMinutes().toString().padStart(2,'0')+'_'+(new Date()).getSeconds().toString().padStart(2,'0');
        },
        PHONE_AUTH: (phoneNumber) => {
            return new Promise((resolve, reject) => {
                Swal.fire({
                    title: '인증번호 발송 중...',
                    text: '잠시만 기다려주세요',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
            
                const verificationCode = Math.floor(100000 + Math.random() * 900000).toString();
                
                axios.post("/api/Common/KKOSendReg", new URLSearchParams({
                    template_code: '025060000443',
                    receiver_num: phoneNumber
                }),
                { withCredentials: true })
                .then(function (response) {
                    if(response.status === 200){
                        let attempts = 0;
                        const maxAttempts = 3;
                        let timeLeft = 180; // 3분 타이머
                        
                        if(response.data === 'N'){
                            Swal.fire({
                                title: '<p style="color:red">휴대폰 인증 실패</p>',
                                html: '인증서버에 오류가 발생 하였습니다.',
                                confirmButtonText: '확인'
                            });
                            resolve('N');
                        }else{
                            const verifyCode = async () => {
                                attempts++;
                                let timer = null; // 타이머 변수를 외부에서 관리
                                
                                const { value: inputCode, isDismissed, dismiss } = await Swal.fire({
                                    title: '인증번호 입력',
                                    html: `
                                        <div style="text-align: center; margin-bottom: 5px;">
                                            <p style="margin-bottom: 10px; color: #666;">
                                                <strong>${phoneNumber}</strong>로 인증번호를 발송했습니다.
                                            </p>
                                            <p id="timer" style="color: #dc3545; font-weight: bold; margin: 0px;">
                                                남은 시간: <span id="countdown">${Math.floor(timeLeft/60)}:${(timeLeft%60).toString().padStart(2, '0')}</span>
                                            </p>
                                        </div>
                                    `,
                                    input: 'text',
                                    inputPlaceholder: '6자리 인증번호 입력',
                                    inputAttributes: {
                                        maxlength: 6,
                                        pattern: '[0-9]*',
                                        style: 'margin-top: 10px; margin-bottom: 10px;',
                                    },                    
                                    showCancelButton: true,
                                    confirmButtonText: '인증확인',
                                    cancelButtonText: '취소',
                                    allowOutsideClick: false,
                                    inputValidator: (value) => {
                                        if (!value) {
                                            return '인증번호를 입력해주세요!'
                                        }
                                        if (value.length !== 6) {
                                            return '6자리 인증번호를 입력해주세요!'
                                        }
                                        if (!/^\d{6}$/.test(value)) {
                                            return '숫자만 입력 가능합니다!'
                                        }
                                    },
                                    didOpen: () => {
                                        // 타이머 시작
                                        timer = setInterval(() => {
                                            timeLeft--;
                                            const minutes = Math.floor(timeLeft / 60);
                                            const seconds = timeLeft % 60;
                                            const countdownEl = document.getElementById('countdown');
                                            
                                            if (countdownEl) {
                                                countdownEl.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;
                                                
                                                // 시간이 30초 이하일 때 빨간색으로 강조
                                                if (timeLeft <= 30) {
                                                    countdownEl.style.color = '#dc3545';
                                                    countdownEl.style.fontWeight = 'bold';
                                                }
                                            }
                                            
                                            if (timeLeft <= 0) {
                                                clearInterval(timer);
                                                timer = null;
                                                Swal.close();
                                                setTimeout(() => {
                                                    Swal.fire({
                                                        title: '<p style="color:red">휴대폰 인증 실패</p>',
                                                        text: '인증시간이 초과되었습니다.',
                                                        confirmButtonText: '확인'
                                                    });
                                                    resolve('N');
                                                }, 100);
                                            }
                                        }, 1000);
                                        
                                        // 숫자만 입력 가능하도록 제한
                                        const input = Swal.getInput();
                                        if (input) {
                                            input.addEventListener('input', function(e) {
                                                e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                            });
                                        }
                                    },
                                    willClose: () => {
                                        // SweetAlert가 닫힐 때 타이머 정리
                                        if (timer) {
                                            clearInterval(timer);
                                            timer = null;
                                        }
                                    }
                                });
                        
                                // SweetAlert가 닫힌 후에도 타이머 정리 (안전장치)
                                if (timer) {
                                    clearInterval(timer);
                                    timer = null;
                                }
                        
                                // 취소 버튼이나 ESC로 닫힌 경우
                                if (isDismissed) {
                                    resolve('N');
                                    return;
                                }
                                if (!inputCode){
                                    resolve('N');
                                    return;
                                } 
                        
                                // 4단계: 인증번호 확인
                                if (String(inputCode) === String(response.data)) {
                                    // 인증 성공
                                    await Swal.fire({
                                        title: '휴대폰 인증 성공',
                                        text: '휴대폰 인증이 성공적으로 완료되었습니다.',
                                        confirmButtonText: '확인',
                                        timer:5000,
                                        timerProgressBar: true
                                    });
                                    resolve('Y');
                                } else {
                                    // 인증 실패
                                    if (attempts >= maxAttempts) {
                                        await Swal.fire({
                                            title: '<p style="color:red">휴대폰 인증 실패</p>',
                                            html: '인증번호를 3회 잘못 입력하셨습니다.<br/>처음부터 다시 시도해주세요.',
                                            confirmButtonText: '확인'
                                        });
                                        resolve('N');
                                    } else {
                                        await Swal.fire({
                                            title: '<p style="color:red">인증번호 불일치</p>',
                                            text: `인증번호가 일치하지 않습니다. (${attempts}/${maxAttempts})`,
                                            confirmButtonText: '확인'
                                        });
                                        verifyCode();
                                    }
                                }
                            };
                            verifyCode();
                        }
                    }
                })
                .catch((error) => {
                    reject(error);
                });
            });
        }
    };

    return (
        <AppContext.Provider value={setting} >
            {props.children}
        </AppContext.Provider>
    );
};
